import { Component, ElementRef, HostListener, Inject } from '@angular/core';
import { SidebarNavMenuItem } from '../../../decorators/sidebar-nav-menu-item';
import { TRAINER_ENTITY_SERVICE_TOKEN } from '../../../injection-tokens/entity-service-tokens';
import { ITrainerEntityService } from '../../../interfaces/entities/trainer-entity-service.interface';
import { TrainerEntity } from '../../../models/entities/trainer';
import { Log, IShortLogger } from '../../../services/logger.service';

@SidebarNavMenuItem({
  route: '/trainer-add-edit',
  faIcon: 'cast_for_education',
  name: 'Trainers',
  order: 400,
  roles: ['admin']
})
@Component({
  selector: 'app-trainer-create-edit',
  templateUrl: './trainer-create-edit.component.html',
  styleUrl: './trainer-create-edit.component.css'
})
export class TrainerCreateEditComponent {
  private readonly logger: IShortLogger<TrainerCreateEditComponent> = Log.create(TrainerCreateEditComponent);

  trainers: TrainerEntity[] = [];
  showModal = false;
  newTrainer: TrainerEntity = new TrainerEntity();
  viewMode: 'detail' | 'card' = 'detail';
  selectedTrainerId: string | undefined = undefined;

  constructor(
    @Inject(TRAINER_ENTITY_SERVICE_TOKEN) public trainerService: ITrainerEntityService,
    private elementRef: ElementRef
  ) { }

  ngOnInit() {
    this.loadTrainers();
  }

  loadTrainers(): void {
    this.trainers = this.trainerService.getAllTrainers();
  }

  openAddTrainer(): void {
    this.newTrainer = new TrainerEntity();
    this.showModal = true;
  }

  closeModal(): void {
    this.showModal = false;
  }

  saveTrainer(event: Event): void {
    event.preventDefault();
    this.trainerService.createTrainer(this.newTrainer, 'admin');
    this.loadTrainers();
    this.closeModal();
  }

  editTrainer(trainer: TrainerEntity): void {
    this.newTrainer = JSON.parse(JSON.stringify(trainer));
    this.showModal = true;
  }

  onViewChange(view: string): void {
    this.viewMode = view as 'detail' | 'card';
  }
  onSkillsChanged(event: any): void {
    const input = event.value || '';
    this.newTrainer.skills = input
      .split(',')
      .map((s: string) => s.trim())
      .filter((s: any) => !!s); // Optional: Remove empty strings
  }

  toggleMenu(event: Event, trainer: TrainerEntity): void {
    if (this.selectedTrainerId != trainer.id)
      this.selectedTrainerId = trainer.id;
    else
      this.selectedTrainerId = undefined;
  }

  deleteTrainer(trainer: any) {
    // Implement deletion logic here
    this.logger.i('Delete clicked for', trainer);
  }
  @HostListener('document:click', ['$event'])
  clickOutside(event: Event): void {
    // Only perform the check if a menu is currently open
    if (this.selectedTrainerId !== undefined) {
      // Check if the click was on a menu toggle button (the ellipsis icon)
      const isMenuToggleClick = (event.target as HTMLElement).classList.contains('menu-icon');

      // If it wasn't a click on the menu toggle button itself
      if (!isMenuToggleClick) {
        // Check if the click was inside the dropdown menu
        const isClickInsideMenu = (event.target as HTMLElement).closest('.dropdown-menu') !== null;

        // If the click was outside the menu, close it
        if (!isClickInsideMenu) {
          this.selectedTrainerId = undefined;
        }
      }
    }
  }
}

